interface SanitizeDomainOptions {
  removeWww?: boolean;
  removeTrailing?: boolean;
}

export default function SanitizeDomainString(
  value: string,
  options: SanitizeDomainOptions = {}
): string {
  const { removeWww = true, removeTrailing = true } = options;

  let result = value
    .trim()
    .toLowerCase()
    .replace(/^[a-z]+:\/+/, "");

  if (removeTrailing) {
    result = result.replace(/\/+$/, "").replace(/\.+$/, "");
  }

  if (removeWww) {
    result = result.replace(/^www\./, "");
  }

  return result;
}
